import axios from 'axios';
import { API_BASE_URL } from '../utils/constants';
import { getAuthToken } from '../utils/storage';
import { extractApiError } from '../utils/apiError';

const attachmentsAPI = axios.create({
    baseURL: `${API_BASE_URL}/api/v1`,
});

attachmentsAPI.interceptors.request.use(
    (config) => {
        const token = getAuthToken();
        if (token) config.headers.Authorization = `Bearer ${token}`;
        return config;
    },
    (error) => Promise.reject(error)
);

const attachmentService = {
    async upload(entityType, entityId, file, remark = '') {
        try {
            const formData = new FormData();
            formData.append('file', file);
            if (remark) formData.append('remark', remark);
            const response = await attachmentsAPI.post(
                `/attachments/${entityType}/${entityId}`,
                formData,
                { headers: { 'Content-Type': 'multipart/form-data' } }
            );
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, error: extractApiError(error) };
        }
    },

    async list(entityType, entityId) {
        try {
            const response = await attachmentsAPI.get(`/attachments/${entityType}/${entityId}`);
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, error: extractApiError(error) };
        }
    },

    async download(attachmentId, { inline = false } = {}) {
        try {
            const response = await attachmentsAPI.get(`/attachments/${attachmentId}/download`, {
                params: inline ? { inline: true } : undefined,
            });
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, error: extractApiError(error) };
        }
    },

    async delete(attachmentId) {
        try {
            const response = await attachmentsAPI.delete(`/attachments/${attachmentId}`);
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, error: extractApiError(error) };
        }
    },

    async uploadForSubOrder(subOrderId, file, remark = '') {
        try {
            const formData = new FormData();
            formData.append('file', file);
            if (remark) formData.append('remark', remark);
            const response = await attachmentsAPI.post(
                `/delivery-sub-orders/${subOrderId}/attachments`,
                formData,
                { headers: { 'Content-Type': 'multipart/form-data' } }
            );
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, error: extractApiError(error) };
        }
    },

    async listForSubOrder(subOrderId) {
        try {
            const response = await attachmentsAPI.get(`/delivery-sub-orders/${subOrderId}/attachments`);
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, error: extractApiError(error) };
        }
    },

    async uploadForAdvice(adviceId, file, remark = '') {
        try {
            const formData = new FormData();
            formData.append('file', file);
            if (remark) formData.append('remark', remark);
            const response = await attachmentsAPI.post(
                `/purchase-advices/${adviceId}/attachments`,
                formData,
                { headers: { 'Content-Type': 'multipart/form-data' } }
            );
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, error: extractApiError(error) };
        }
    },

    async listForAdvice(adviceId) {
        try {
            const response = await attachmentsAPI.get(`/purchase-advices/${adviceId}/attachments`);
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, error: extractApiError(error) };
        }
    },
};

export default attachmentService;
